/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FboLocationResponse } from '../../models/fbo-location-response';

export interface GetFboLocationDetails$Params {

/**
 * The ID of the FBO location to retrieve.
 */
  id: number;
}

export function getFboLocationDetails(http: HttpClient, rootUrl: string, params: GetFboLocationDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<FboLocationResponse>> {
  const rb = new RequestBuilder(rootUrl, getFboLocationDetails.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FboLocationResponse>;
    })
  );
}

getFboLocationDetails.PATH = '/api/administration/fbo-locations/{id}';
